module.exports = __webpack_public_path__ + "images/help/icon-twr53@2x-80552cc255bc766d515e2f5cf7b3dabb.png";